var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start",class:this.$store.entregaStore.state.selectedType === 2 || this.$store.entregaStore.state.selectedType === 3 ? 'scrollable-list-bak':'',staticStyle:{"height":"100%"},attrs:{"fluid":"","pa-0":""}},[_c('FullHeader'),_c('EntregasContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }